import { useState } from 'react';
import { aboutInfo } from '@/mocks/about';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    // Honeypot check
    const phoneAlt = formData.get('phone_alt') as string;
    if (phoneAlt && phoneAlt.trim() !== '') {
      setFormStatus('success');
      setSubmitting(false);
      return;
    }

    try {
      const res = await fetch('http://baoliaogua.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'phone_alt')
            .map(([k, v]) => [k, typeof v === 'string' ? v : ''])
        ).toString(),
      });

      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(serverMsg || '提交失败，请稍后再试');
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
      setFormStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="w-full py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            有爆料线索或商务合作需求？欢迎联系我们
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 max-w-5xl mx-auto">
          {/* Contact Info */}
          <div className="flex-1 space-y-6">
            <h3 className="font-heading text-base font-semibold text-foreground-900">
              联系方式
            </h3>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">邮箱</p>
                  <p className="text-sm text-foreground-500">{aboutInfo.contact.email}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">微信</p>
                  <p className="text-sm text-foreground-500">{aboutInfo.contact.wechat}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0">
                  <i className="ri-weibo-line text-secondary-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">微博</p>
                  <p className="text-sm text-foreground-500">{aboutInfo.contact.weibo}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center shrink-0">
                  <i className="ri-map-pin-line text-foreground-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">地址</p>
                  <p className="text-sm text-foreground-500">{aboutInfo.contact.address}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="flex-1">
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-5">
              商务合作咨询
            </h3>

            {formStatus === 'success' ? (
              <div className="bg-accent-100 rounded-lg p-8 text-center">
                <div className="w-14 h-14 mx-auto bg-accent-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-2xl text-background-50"></i>
                </div>
                <h4 className="font-heading text-lg font-semibold text-foreground-900 mt-4">
                  提交成功！
                </h4>
                <p className="text-foreground-500 text-sm mt-2">
                  感谢您的咨询，我们会在1-2个工作日内与您联系。
                </p>
                <button
                  onClick={() => setFormStatus('idle')}
                  className="mt-4 text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  继续提交
                </button>
              </div>
            ) : (
              <form
                id="contact-form"
               
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="请输入您的姓名"
                  />
                </div>

                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="请输入您的邮箱"
                  />
                </div>

                <div>
                  <label htmlFor="contact-company" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    公司/机构
                  </label>
                  <input
                    id="contact-company"
                    name="company"
                    type="text"
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="请输入您的公司或机构名称"
                  />
                </div>

                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    合作需求
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                    placeholder="请描述您的合作需求（限500字）"
                  />
                  <p className="text-foreground-400 text-xs mt-1">最多500字符</p>
                </div>

                {/* Honeypot */}
                <div className="absolute opacity-0 pointer-events-none" style={{ height: '0px', overflow: 'hidden' }}>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>

                {formStatus === 'error' && formError && (
                  <div className="bg-primary-50 border border-primary-200 rounded-lg p-3 flex items-start gap-2">
                    <i className="ri-error-warning-line text-primary-500 mt-0.5"></i>
                    <p className="text-sm text-primary-700">{formError}</p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {submitting ? '提交中...' : '提交咨询'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}